// @ts-nocheck

import { supabase } from '@/lib/supabase';
import { invokeEdgeFunction } from "@/lib/invokeEdgeFunction";

export interface EventNotificationData {
  event_id: string;
  notification_type: 'team_registration' | 'individual_registration' | 'roster_submitted' | 'roster_missing' | 'checkin_activity' | 'payment_completed' | 'event_update' | 'schedule_change' | 'weather_update' | 'reminder' | 'custom_notification';
  event_name: string;
  action_description: string;
  email_data?: {
    event_date?: string;
    venue_name?: string;
    venue_city?: string;
    venue_state?: string;
    recipient_name?: string;
    message?: string;
    subject?: string;
  };
}

export const triggerEventNotification = async (data: EventNotificationData): Promise<boolean> => {
  try {
    console.log('Triggering event notification:', data);
    
    const { data: result, error } = await invokeEdgeFunction('send-event-notification', {
      body: data
    });

    if (error) {
      console.error('Error invoking notification function:', error);
      return false;
    }

    console.log('Notification function result:', result);
    return true;
  } catch (error) {
    console.error('Exception triggering event notification:', error);
    return false;
  }
};

// Helper functions for common notification scenarios
export const notifyTeamRegistration = async (eventId: string, eventName: string) => {
  return triggerEventNotification({
    event_id: eventId,
    notification_type: 'team_registration',
    event_name: eventName,
    action_description: 'A new team has registered for this event.'
  });
};

export const notifyIndividualRegistration = async (eventId: string, eventName: string) => {
  return triggerEventNotification({
    event_id: eventId,
    notification_type: 'individual_registration',
    event_name: eventName,
    action_description: 'A new individual has registered for this event.'
  });
};

export const notifyRosterSubmitted = async (eventId: string, eventName: string, teamName?: string) => {
  const description = teamName 
    ? `Team "${teamName}" has submitted their roster.`
    : 'A team has submitted their roster.';
    
  return triggerEventNotification({
    event_id: eventId,
    notification_type: 'roster_submitted',
    event_name: eventName,
    action_description: description
  });
};

export const notifyRosterMissing = async (eventId: string, eventName: string, deadline: string) => {
  return triggerEventNotification({
    event_id: eventId,
    notification_type: 'roster_missing',
    event_name: eventName,
    action_description: `Roster deadline is approaching (${deadline}). Some teams have not submitted their rosters.`
  });
};

export const notifyCheckinActivity = async (eventId: string, eventName: string, participantName?: string) => {
  const description = participantName
    ? `${participantName} has completed check-in.`
    : 'A participant has completed check-in.';
    
  return triggerEventNotification({
    event_id: eventId,
    notification_type: 'checkin_activity',
    event_name: eventName,
    action_description: description
  });
};

export const notifyPaymentCompleted = async (eventId: string, eventName: string, amount?: number, payerName?: string) => {
  let description = 'A payment has been completed for this event.';
  
  if (payerName && amount) {
    description = `${payerName} has completed payment of $${amount.toFixed(2)}.`;
  } else if (payerName) {
    description = `${payerName} has completed their payment.`;
  } else if (amount) {
    description = `A payment of $${amount.toFixed(2)} has been completed.`;
  }
  
  return triggerEventNotification({
    event_id: eventId,
    notification_type: 'payment_completed',
    event_name: eventName,
    action_description: description
  });
};